
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return require("private-next-pages/news/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news"])
      });
    }
  